import React from 'react';
import PropTypes from 'prop-types';
import { StyledHeader, StyledInfo } from './styles';
import PickupDate from './pickup-date';
import ModalLink from './modal-link';
var string = PropTypes.string,
  func = PropTypes.func,
  bool = PropTypes.bool;
var Pickup = function Pickup(_ref) {
  var pickupHeaderMessage = _ref.pickupHeaderMessage,
    minPickupDate = _ref.minPickupDate,
    maxPickupDate = _ref.maxPickupDate,
    pickupTodayMessage = _ref.pickupTodayMessage,
    pickupTomorrowMessage = _ref.pickupTomorrowMessage,
    pickupStoreLocation = _ref.pickupStoreLocation,
    pickupAtMessage = _ref.pickupAtMessage,
    openPickupModal = _ref.openPickupModal,
    pickupFindStoreMessage = _ref.pickupFindStoreMessage,
    pickupUnavailableMessage = _ref.pickupUnavailableMessage,
    timeZone = _ref.timeZone,
    language = _ref.language,
    pickupIneligibleMessage = _ref.pickupIneligibleMessage,
    showPickupIneligibleMessage = _ref.showPickupIneligibleMessage,
    learnMoreMessage = _ref.learnMoreMessage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledHeader, {
    className: "pickup-header"
  }, pickupHeaderMessage()), /*#__PURE__*/React.createElement(StyledInfo, {
    className: "pickup-info"
  }, maxPickupDate && /*#__PURE__*/React.createElement(PickupDate, {
    maxPickupDate: maxPickupDate,
    minPickupDate: minPickupDate,
    pickupTodayMessage: pickupTodayMessage,
    pickupTomorrowMessage: pickupTomorrowMessage,
    timeZone: timeZone,
    language: language
  }), showPickupIneligibleMessage ?
  /*#__PURE__*/
  /* Pickup is Ineligible - items are digital only, custom, or have VAS */
  React.createElement(React.Fragment, null, pickupIneligibleMessage(), /*#__PURE__*/React.createElement(ModalLink, {
    fallbackMessage: learnMoreMessage,
    onClick: openPickupModal
  })) :
  /*#__PURE__*/
  /* Unavailable message - only when there is postalCode and storeName */
  React.createElement(React.Fragment, null, !maxPickupDate && pickupStoreLocation && pickupUnavailableMessage(), /*#__PURE__*/React.createElement(ModalLink, {
    className: "pickup",
    dataAutomation: "bopis-link",
    toOrAtMessage: pickupAtMessage,
    fallbackMessage: pickupFindStoreMessage,
    postalCodeOrStoreName: pickupStoreLocation,
    onClick: openPickupModal
  }))));
};
Pickup.propTypes = {
  pickupHeaderMessage: func,
  maxPickupDate: string,
  minPickupDate: string,
  pickupTodayMessage: func,
  pickupTomorrowMessage: func,
  pickupStoreLocation: string,
  openPickupModal: func,
  pickupFindStoreMessage: func,
  learnMoreMessage: func,
  pickupUnavailableMessage: func,
  pickupAtMessage: func,
  timeZone: string,
  language: string,
  pickupIneligibleMessage: func,
  showPickupIneligibleMessage: bool
};
export default Pickup;